import {ConfirmationButtonType} from "../common-components/popups/confirmation/confirmation-button-type.enum";

export class ConfirmationButton {
  public text: string = '';
  public type: ConfirmationButtonType = ConfirmationButtonType.Cancel;
  public target?: string = undefined;

  public constructor(init?:Partial<ConfirmationButton>) {
    Object.assign(this, init);
  }
}
